import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: Record<string, Record<string, boolean>> = {
  viewTemplates: { Owner: true, Admin: true, Designer: true, Marketer: true },
  createTemplates: {
    Owner: true,
    Admin: true,
    Designer: true,
    Marketer: false,
  },
  updateTemplates: {
    Owner: true,
    Admin: true,
    Designer: true,
    Marketer: false,
  },
  deleteTemplates: {
    Owner: true,
    Admin: true,
    Designer: true,
    Marketer: false,
  },
  duplicateTemplates: {
    Owner: true,
    Admin: true,
    Designer: true,
    Marketer: false,
  },
  sendTestEmails: { Owner: true, Admin: true, Designer: true, Marketer: false },
  createCampaign: { Owner: true, Admin: true, Designer: false, Marketer: true },
  editCampaign: { Owner: true, Admin: true, Designer: false, Marketer: true },
  createAutomation: {
    Owner: true,
    Admin: true,
    Designer: false,
    Marketer: true,
  },
  editAutomation: { Owner: true, Admin: true, Designer: false, Marketer: true },
  inviteMember: { Owner: true, Admin: true, Designer: false, Marketer: false },
  manageMember: { Owner: true, Admin: true, Designer: false, Marketer: false },
  removeMember: { Owner: true, Admin: true, Designer: false, Marketer: false },
};

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    // Saves updated role permissions to the Redux store
    saveRoles: (
      _,
      action: PayloadAction<Record<string, Record<string, boolean>>>
    ) => {
      return action.payload;
    },
  },
});

export const { saveRoles } = rolesSlice.actions;
export default rolesSlice.reducer;
